export default "__VITE_ASSET__7056d8f6__"